"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyEvaluator = void 0;
var wildstring = require('wildstring');
var PolicyEvaluator = /** @class */ (function () {
    function PolicyEvaluator() {
    }
    PolicyEvaluator.methodAllowed = function (policies, service, method) {
        var items = [];
        service = service.toLowerCase();
        method = method.toLowerCase();
        policies.forEach(function (policy) {
            items.push.apply(items, policy.statements.filter(function (statement) {
                var result = false;
                for (var _i = 0, _a = statement.actions; _i < _a.length; _i++) {
                    var action = _a[_i];
                    var not = false;
                    if (action.startsWith('!')) {
                        action = action.substr(1);
                        not = true;
                    }
                    var _b = action.split(':'), r = _b[0], m = _b[1];
                    if (action === '*' ||
                        ((r === '*' || r === service) &&
                            (m.toLowerCase() === method ||
                                wildstring.match(m.toLowerCase(), method)))) {
                        result = true;
                        if (not) {
                            return false;
                        }
                    }
                }
                return result;
            }));
        });
        return items.length > 0;
    };
    return PolicyEvaluator;
}());
exports.PolicyEvaluator = PolicyEvaluator;
